import { render, staticRenderFns } from "./WhitelabelFont.vue?vue&type=template&id=69a1c65d&scoped=true&"
import script from "./WhitelabelFont.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelFont.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelFont.vue?vue&type=style&index=0&id=69a1c65d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a1c65d",
  null
  
)

export default component.exports